export const status = {
  draft: 'Draft',
  archived: 'Archived',
  published: 'Published',
} as const
